import { createFileRoute } from "@tanstack/react-router";
import { CaixasPage } from "@/pages/CaixasPage";

export const Route = createFileRoute("/caixas/")({
  head: () => ({ meta: [{ title: "Caixas — AXIS Comprovantes" }] }),
  component: () => <CaixasPage />,
});
